import * as React from 'react'

import CircularProgress from '@material-ui/core/CircularProgress'
import styled from 'styled-components'

const ProgressWrapper = styled.div`
  padding: 10px;
  height: 52px;
  min-height: 52px;
  width: 52px;
  min-width: 52px;
  border-radius: 50%;
  box-shadow: ${({ theme: { shadows } }) => shadows[4]};
`

export default () => (
  <ProgressWrapper>
    <CircularProgress size={32} />
  </ProgressWrapper>
)



// WEBPACK FOOTER //
// ./src/components/atoms/Loader.tsx